import { Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { places } from "src/app/app.const";
import { Utils } from "src/app/app.utils";
import { AdminService } from "src/app/core/endpoints/admin.service";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { User } from "src/app/core/endpoints/models/user.model";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { confirmPassword } from "src/app/core/utils/utils";
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';


@Component({
	selector: "app-my-data",
	templateUrl: "./my-data.component.html",
	styleUrls: ["./my-data.component.scss"],
})
export class MyDataComponent {
	imageChangedEvent: Event | null = null;
	croppedActive: boolean  = false;

	@ViewChild("fileInput") fileInput: any;

	public user: User = null;
	public loading: boolean = false;
	public confirmUpdateDialog: boolean = false;
	public newEmail: string;
	public newName: string;
	public newSurname: string;
	public newNumberDocument: string;
	public photo: File;
	public stringPhoto: any = '';

	public form: FormGroup = this.fb.group({
		name: [
			"",
			[Validators.required],
		],
		surname: [
			"",
			[Validators.required],
		],
		phone_number: ["", Validators.pattern(/^\+[0-9 ]+$/)],
		email: ["", [Validators.required, Validators.email]],
		number_document: [""],
		password: [""],
		password_confirmation: ["", confirmPassword],
		role_id: [""],
		avatar: [""],
	});

	constructor(
		private fb: FormBuilder,
		protected toast: ToastService,
		private apiService: ApiService
		
	) {
		this.getUser();
	}

	ngOnInit() {
		// this.loading = true;
	}

	/**
	 * Obtener y/o editar datos del usuario actual en sesión
	 */
	public async getUser() {
		this.apiService.getEntity("user").subscribe({
			next: (result) => {
				this.user = result.user;
				this.form.patchValue(this.user);
				if (this.user.avatar){
					this.stringPhoto = this.user.avatar;
				}
				AuthService.setDataUser(result.user);
			},
			error: (err) => {
				this.user = JSON.parse(localStorage.getItem("user"));
			},
			complete: () => {},
		});
	}

	/**
	 * Enviar formulario de edición de usuario
	 */
	public async saveUser() {
		const message1 = "Aviso";
		const message2 = "Faltan datos en el formulario";
		const message3 = "Introduzca número de teléfono con formato correcto";
		const message4 = "Datos modificados correctamente";
		const message5 = "Error";
		const message6 = "Error al modificar tus datos. Revisa el formulario";

		if (this.user.role_id === 2 || this.user.role_id === 1) {
			if (
				this.form.get("name").value === "" ||
				this.form.get("email").value === "" ||
				this.form.get("password").value !==
					this.form.get("password_confirmation").value
			) {
				return this.toast.show(message1, message2, "warn");
			}
		} else if (this.user.role_id === 3) {
			if (this.form.get("phone_number").value === "") {
				return this.toast.show(message1, message3, "warn");
			}
			if (this.form.invalid) {
				return this.toast.show(message1, message2, "warn");
			}
		}

		this.loading = true;
		this.form.patchValue({ avatar: this.stringPhoto });

		this.apiService
		.updateEntity(
			"updateUserFromAdmin",
			this.user.id,
			this.form.value
		)
		.subscribe({
			next: (result) => {
				this.loading = false;
				this.toast.show("Datos actualizados correctamente");
				this.getUser();
				this.confirmUpdateDialog = false;
				this.croppedActive = false;
			},
			error: (err) => {
				this.loading = false;
				let message = "Ocurrió un error al editar el usuario, inténtelo de nuevo";
				if (err && err.error && err.error.errors){
					message = '';
					let errors = err.error.errors;
					for (const field in errors) {
						errors[field].forEach((errorMessage) => {
							message += `${errorMessage}\n`;
						});
					}
				}
				this.loading = false;
				this.toast.show(
					"Error",
					message,
					"error"
				);
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	/**
	 * Obtener localización trás aceptar permisos
	 */

	public handleConfirmUpdate() {
		this.confirmUpdateDialog = true;
		if (this.form.get("email").value) {
			this.newEmail = this.form.get("email").value;
		}

		if (this.form.get("name").value) {
			this.newName = this.form.get("name").value;
		}

		if (this.form.get("surname").value) {
			this.newSurname = this.form.get("surname").value;
		}

		if (this.form.get("number_document").value) {
			this.newNumberDocument = this.form.get("number_document").value;
		}
		
	}

	public handleUpload($event: any) {
		this.imageChangedEvent = $event;
		this.croppedActive = true;

		// try {
		// 	const files: FileList = $event.target.files;
		// 	this.photo = Utils.renameFile(files[0], new Date().getTime().toString());
		// 	var reader = new FileReader();
		// 	if (this.photo.type === "image/jpeg" || this.photo.type === "image/png") {
		// 		reader.onloadend = async () => {
		// 			$event.target.value = "";
		// 			this.stringPhoto = String(reader.result);
		// 		};
		// 		reader.readAsDataURL(this.photo);
		// 	} else {
		// 		return this.toast.show(
		// 			"Aviso",
		// 			"El formato de la imagen debe ser PNG o JPG",
		// 			"warn"
		// 		);
		// 	}
		// } catch (error) {
		// 	console.log(error);
		// }
	}
	
	public deletePhoto() {
		this.stringPhoto = undefined;
		this.croppedActive = false;
	}
	
    imageCropped(event: ImageCroppedEvent) {
      this.stringPhoto = event.base64;
    }
    imageLoaded(image: LoadedImage) {
    }
    cropperReady() {
    }
    loadImageFailed() {
    }

}
